/* BeautySkin — comportamiento común de las secciones bs-* */
(function () {
  function init(root) {
    // Aparición suave al hacer scroll
    var els = root.querySelectorAll('.bs-reveal:not(.is-in)');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: .12 });
      els.forEach(function (el) { io.observe(el); });
    } else els.forEach(function (el) { el.classList.add('is-in'); });
    // Contadores animados
    root.querySelectorAll('[data-bs-count]:not([data-done])').forEach(function (el) {
      var m = (el.dataset.bsCount || '').match(/^(\d+)(.*)$/); if (!m) return;
      el.dataset.done = 1; var n = +m[1], suf = m[2];
      var go = function () { var t0 = performance.now(); (function f(t) { var k = Math.min(1, (t - t0) / 1100); el.textContent = Math.round(n * k) + suf; if (k < 1) requestAnimationFrame(f); })(t0); };
      if ('IntersectionObserver' in window) { var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { go(); o.disconnect(); } }); o.observe(el); } else go();
    });
    // Fecha de entrega estimada (hoy + min..max días)
    root.querySelectorAll('[data-bs-eta]').forEach(function (el) {
      var p = el.dataset.bsEta.split('-'), d1 = new Date(), d2 = new Date();
      d1.setDate(d1.getDate() + (+p[0])); d2.setDate(d2.getDate() + (+p[1]));
      var f = function (d) { return d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' }).replace('.', ''); };
      el.textContent = f(d1) + ' y el ' + f(d2);
    });
    // Añadir al carrito (formularios con data-bs-atc) y abrir el carrito
    root.querySelectorAll('form[data-bs-atc]:not([data-bound])').forEach(function (form) {
      form.dataset.bound = 1;
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var btn = form.querySelector('[type=submit]'); if (btn) btn.setAttribute('aria-busy', 'true');
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +form.querySelector('[name=id]').value, quantity: +(form.querySelector('[name=quantity]') || { value: 1 }).value }] }) })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; })
          .catch(function () { form.submit(); });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
